import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Locale Selection Banner",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-locale-selection-banner",
    args: { url: "./mock-data/locale-selection-banner/locales.json" },
    argTypes: { url: { control: "text" } },
};

const Template = ({ url }) =>
    html`<ux-iws-locale-selection-banner
        url="${url}"
    ></ux-iws-locale-selection-banner>`;

export const Default = Template.bind({});

export const NoShow = Template.bind({});
NoShow.args = {
    url: "./mock-data/locale-selection-banner/languages-no-show.json",
};
